// extracted by mini-css-extract-plugin
module.exports = {"gpt":"S3S_czJ_"};